import * as amplitude from "@amplitude/analytics-browser";
import type { BulkActionType } from "../activity/labels";

export type FormActionVerb =
  | "Clicked"
  | "Confirmed"
  | "Canceled"
  | "Queued"
  | "Failed"
  | "Completed";

const ACTION_EVENT_LABELS: Record<BulkActionType, string> = {
  SET_FORM_STATUS: "update form status",
  SET_FORM_VISIBILITY: "update visibility",
  VERIFY_FORM: "verify",
  EXECUTE_FORM_RULES: "execute form rules",
  ADD_TO_WAITLIST: "add to waitlist",
  REMOVE_FROM_WAITLIST: "remove from waitlist",
  MAKE_OFFER: "make offer",
  ACCEPT_OFFER: "accept offer",
  DECLINE_OFFER: "decline offer",
  REVOKE_OFFER: "revoke offer",
  CLEAR_AUTO_REVOKE: "clear offer expiration",
  EXCLUDE_FROM_OFFERS: "exclude from offers",
  CLEAR_SUBSTATUS: "clear substatus",
  ADD_TAG: "add tag",
  REMOVE_TAG: "remove tag",
};

export type TrackFormActionArgs = {
  verb: FormActionVerb;
  actionType: BulkActionType;
  bulk: boolean;
  count: number;
  async: boolean;
  extra?: Record<string, unknown>;
};

export function trackFormAction({
  verb,
  actionType,
  bulk,
  count,
  async: isAsync,
  extra,
}: TrackFormActionArgs): void {
  const label = ACTION_EVENT_LABELS[actionType];
  const eventName = bulk ? `${verb} bulk ${label}` : `${verb} ${label}`;
  amplitude.track(eventName, {
    action_type: actionType,
    count,
    async: isAsync,
    ...extra,
  });
}

export function trackFormActionError(
  err: unknown,
  args: Omit<TrackFormActionArgs, "verb" | "extra"> & {
    extra?: Record<string, unknown>;
  }
): void {
  const errorName =
    err instanceof Error
      ? err.constructor.name
      : typeof err === "string"
      ? "String"
      : "Unknown";
  trackFormAction({
    ...args,
    verb: "Failed",
    extra: { ...args.extra, error_name: errorName },
  });
}
